import React, { useState } from "react";
import { createCtx } from "./ContextHelper";

interface UIContextProps {
  children: React.ReactNode;
}

type UIContextType = {
  sideMenuOpen: boolean;
  setSideMenuOpen: (value: boolean) => void;
  settingSideSubMenuOpen: boolean;
  setSettingsSubMenuOpen: (value: boolean) => void;
  orgSideSubMenuOpen: boolean;
  setOrgSideSubMenuOpen: (value: boolean) => void;
};

export const [useUIContext, CtxProvider] = createCtx<UIContextType>();

export const UIContextProvider = ({ children }: UIContextProps) => {
  const [sideMenuOpen, setSideMenuOpen] = useState<boolean>(false);
  const [orgSideSubMenuOpen, setOrgSideSubMenuOpen] = useState<boolean>(false);
  const [settingSideSubMenuOpen, setSettingsSubMenuOpen] =
    useState<boolean>(false);

  return (
    <CtxProvider
      value={{
        sideMenuOpen,
        setSideMenuOpen,
        settingSideSubMenuOpen,
        setSettingsSubMenuOpen,
        orgSideSubMenuOpen,
        setOrgSideSubMenuOpen
      }}
    >
      {children}
    </CtxProvider>
  );
};
